import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'person_matches',
  })

  return function onClick() {
    return submit({ type: 'ignoreMatches' })
  }
}
